import { Grid } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import AcxVirtualizedSelectMulti from "components/UI/Select/AcxVirtualizedSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";
import {
    getClassifierOptionsForCategory,
    normalizeClassifierCategoryId,
} from "./classifierUtils";

type ClassifierControlsProps = {
    store: ChartCardStore;
    showComparePrevCheckbox: boolean;
};

const ClassifierControls = observer(
    ({ store, showComparePrevCheckbox }: ClassifierControlsProps) => {
        const classifierCategoryId = normalizeClassifierCategoryId(
            store.selectedIds["classifierCategory"] as string | undefined,
        );
        const classifiersToShow = getClassifierOptionsForCategory(
            store,
            classifierCategoryId,
        );

        const optionsLoading =
            store.optionsStore.classifierCategoriesLoading ||
            store.optionsStore.userClassifiersLoading;

        return (
            <Grid
                item
                container
                xs={showComparePrevCheckbox ? 6 : 8}
                spacing={2}
                alignItems={"flex-end"}
            >
                <Grid item xs={6}>
                    <AcxSelect
                        fullWidth
                        defaultValue={
                            classifierCategoryId
                                ? store.optionsStore.classifierCategories.find(
                                      (category) =>
                                          category.id === classifierCategoryId,
                                  )
                                : undefined
                        }
                        options={store.optionsStore.classifierCategories ?? []}
                        onChange={(item) => {
                            store.setSelectedId(
                                "classifierCategory",
                                normalizeClassifierCategoryId(item?.id),
                            );
                            store.setSelectedId("classifiers", []);
                            store.handleSelectionChange();
                        }}
                        placeholder="All Classifiers"
                        id={`signals-chart-select-classifier-category-${store.id}`}
                        labelField="name"
                        valueField="id"
                        alternateItemColor={theme.palette.gray.main}
                        isClearable
                        isLoading={optionsLoading}
                        isDisabled={store.isReadOnly}
                        disabledAppearance="readOnly"
                    />
                </Grid>
                <Grid item xs={6}>
                    <AcxVirtualizedSelectMulti
                        options={classifiersToShow}
                        id={`classifier-select-${store.id}`}
                        onApply={(ids) => {
                            store.setSelectedId("classifiers", ids);
                            store.handleSelectionChange();
                        }}
                        itemName="Classifier"
                        defaultSelectedIds={
                            store.selectedIds["classifiers"] as
                                | string[]
                                | undefined
                        }
                        labelField="name"
                        idField="id"
                        maxSelectionCount={store.getMaxSelection()}
                        isLoading={optionsLoading}
                        enableCompactLayout
                        disabled={store.isReadOnly}
                        disabledAppearance="readOnly"
                    />
                </Grid>
            </Grid>
        );
    },
);

export default ClassifierControls;
